<div class="branding mb-4" *ngIf="branding">
  <x-media-thumbnail
    url="https://res.cloudinary.com/babylon/image/upload/v1588832764/bt-shop/svg/logo_qzkdim.svg"
    width="80"
    height="80"
    crop="fit"
  ></x-media-thumbnail>
</div>

<header *ngIf="heading" class="heading mb-4" [style.text-align]="alignment">
  <h3>{{ heading }}</h3>

  <div class="my-2" *ngIf="subHeading">
    {{ subHeading }}
  </div>
</header>

<ng-content select="form"></ng-content>

<ng-content></ng-content>

<div class="form-actions">
  <ng-content select="[xFormAction]"></ng-content>
</div>

<div class="form-errors">
  <ng-content select="[xFormErrors]"></ng-content>
</div>

<x-loader *ngIf="loading"></x-loader>
